import { combineReducers } from 'redux';
import { app } from './App';
import { contacts } from './Contacts';
import { dtcCampaign } from './DTCCampaigns';
import { dashboard } from './Dashboard';
import { hubCampaigns } from './HubCampaigns';
import { influencerCampaign } from './InfluencerCampaigns';
import { loading } from './Loading';
import { plan } from './Plan';
import { recruit } from './Recruit';
import { signUpFlow } from './SignUpFlow';

const rootReducer = combineReducers({
    loading,
    hubCampaigns,
    dashboard,
    app,
    contacts,
    recruit,
    signUpFlow,
    plan,
    dtcCampaign,
    influencerCampaign,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
